export default __webpack_public_path__ + "media/images/favicon-f9f6e286cd525f93caafaf201a060b77.png";